import {url} from "./urls";
import {isEmptyList} from "./objects";
import {isNotEmpty} from "./strings";

export const _CONST_LIST_SEARCH_KEY = "k";
export const _CONST_LIST_MENU_CODE = "mc";
export const _CONST_LIST_MENU_CODES = "mcs";
export const _CONST_LIST_ALL_MENU_CODES = "smcs";
export const _CONST_LIST_BRAND_CODE = "bc";
export const _CONST_LIST_INDEX = "idx";

export const _INIT_LIST_SEARCH_DATA = {k: "", idx: 0};

const _SPLIT_STRING = ",";


/**
 * 検索用のパラメータを設定する
 */
export function buildSearchParams(params, {
  keywords,
  pageIndex,
  menuCode,
  menuCodes,
  allMenuCodes,
  brandCode,
}) {
  if(keywords !== undefined) {
    params.set(_CONST_LIST_SEARCH_KEY, keywords);

  }
  if(pageIndex !== undefined) {
    params.set(_CONST_LIST_INDEX, pageIndex);
  }

  if(menuCode !== undefined) {
    params.set(_CONST_LIST_MENU_CODE, menuCode);
  }

  if(menuCodes !== undefined) {
    params.set(_CONST_LIST_MENU_CODES, menuCodes);
  }
  if(brandCode !== undefined) {
    params.set(_CONST_LIST_BRAND_CODE, brandCode);
  }
  if(allMenuCodes !== undefined) {
    params.set(_CONST_LIST_ALL_MENU_CODES, allMenuCodes);
  }
  params.set("stop", true);
}

/**
 * 複数のメニュコードをカンマ区切りで文字列に連結
 * @param lowerMenus
 * @param all
 * @returns {string}
 */
export function jointMenuCodeParams(lowerMenus = [], all = false) {
  // メニューコードを作成する
  const menuCodeArray = [];
  if(!isEmptyList(lowerMenus)) {
    for (const menu of lowerMenus) {
      let isChildren = false;
      if (!isEmptyList(menu.children)) {
        // 子要素が存在する場合子要素のみ
        for (const child of menu.children) {
          if (child.selected) {
            menuCodeArray.push(child.cmenu_code);
            isChildren = true;
          }
        }
      }
      // 子要素がない場合は親追加
      if (!isChildren || all) {
        if (menu.selected) {
          menuCodeArray.push(menu.cmenu_code);
        }
      }
    }
  }
  return menuCodeArray.join(_SPLIT_STRING);
}

/**
 * メニューコード文字列を配列に分割する
 * @param menuCodes
 * @returns {string[]|*[]}
 */
export function splitMenuCodeParams(menuCodes = "") {
  if(isNotEmpty(menuCodes)) {
    return menuCodes.split(",")
  } else {
    return []
  }
}

export function buildQueryPrams(query) {
  const params = {};
  if(isNotEmpty(query)) {
    const queryArray1 = query.split("&");
    if (!isEmptyList(queryArray1)) {
      for (const param1 of queryArray1) {
        const queryArray2 = param1.split("=");
        if (!isEmptyList(queryArray2)) {
          if (queryArray2.length === 2) {
            params[queryArray2[0]] = queryArray2[1];
          }
        }
      }
    }
  }
  return params;
}


export function searchKeyword(keyword) {
  return url("/list/?k=" + keyword);
}